// extracted by mini-css-extract-plugin
export var cardIcon = "_5x-4";
export var checkboxCard = "_5x-0";
export var checkboxCardSelected = "_5x-3";
export var disabled = "_5x-1";
export var outerBorder = "_5x-2";
export var spacerMedium = "_5x-7";
export var spacerSmall = "_5x-6";
export var spacerXsmall = "_5x-5";